module.exports = __webpack_public_path__ + "static/wo-placeholder-7b40d343add90b65c30b00449a12a6c5.png";